export function generateGoogleFontsUrl(fontFamily: string, weight: string) {
    return `https://fonts.googleapis.com/css?family=${fontFamily}:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i,1000,1000i,${weight},${weight}i|serif`;
}
